// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7O9ur","header":"ons75","ok-button":"_2bhGH","okButton":"_2bhGH","sub-footer":"_3Jr6B","subFooter":"_3Jr6B","mobileLogoutBtn":"I6-P2"};